export const headerMail = {
    title: 'Mail regroupé',
    submodules: [
    ],
}

function createData(id, moduleName, ref) {
    return { id, moduleName, ref };
}